// Bundle & save box on product pages (rendered by snippets/bundle-together.liquid)
if (!customElements.get('bundle-together')) {
  customElements.define(
    'bundle-together',
    class extends HTMLElement {
      connectedCallback() {
        this.querySelectorAll('[data-bundle-item]').forEach((box) => box.addEventListener('change', () => this.update()));
        this.querySelector('[data-bundle-add]').addEventListener('click', () => this.add());
        this.prices = {};
        fetch(this.dataset.productUrl + '.js')
          .then((r) => r.json())
          .then((p) => { p.variants.forEach((v) => (this.prices[v.id] = v.price)); this.update(); })
          .catch(() => {});
        // Keep 'This item' in step with the size/colour picked on the page
        document.addEventListener('change', () => setTimeout(() => this.update(), 400));
        this.update();
      }

      format(pence) {
        return '£' + (pence / 100).toFixed(2);
      }

      checked() {
        return [...this.querySelectorAll('[data-bundle-item]:checked')];
      }

      // Use whichever variant is currently selected in the main product form
      currentVariantId(box) {
        const input = document.querySelector('.product-details form input[name="id"]');
        return input && input.value ? input.value : box.dataset.variantId;
      }

      update() {
        const current = this.querySelector('[data-current]');
        const price = this.prices && this.prices[this.currentVariantId(current)];
        if (price) {
          current.dataset.price = price;
          current.closest('label').querySelector('.bundle-together__price').textContent = this.format(price);
        }
        const items = this.checked();
        const total = items.reduce((sum, box) => sum + Number(box.dataset.price), 0);
        const discounted = items.length >= 2 ? Math.round(total * 0.9) : total;
        const button = this.querySelector('[data-bundle-add]');
        this.querySelector('[data-bundle-total]').textContent = this.format(discounted);
        const was = this.querySelector('[data-bundle-was]');
        const saving = this.querySelector('[data-bundle-saving]');
        was.hidden = saving.hidden = discounted === total;
        was.textContent = this.format(total);
        saving.textContent = 'You save ' + this.format(total - discounted);
        button.disabled = items.length === 0;
        button.textContent = items.length > 1 ? 'Add all ' + items.length + ' to basket' : 'Add to basket';
      }

      async add() {
        const button = this.querySelector('[data-bundle-add]');
        const error = this.querySelector('[data-bundle-error]');
        const items = this.checked().map((box) => ({
          id: Number(box.hasAttribute('data-current') ? this.currentVariantId(box) : box.dataset.variantId),
          quantity: 1,
        }));
        button.disabled = true;
        error.hidden = true;
        try {
          const response = await fetch(this.dataset.cartAddUrl + '.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items }),
          });
          if (!response.ok) throw new Error(await response.text());
          window.location.href = this.dataset.cartUrl;
        } catch (e) {
          error.hidden = false;
          button.disabled = false;
        }
      }
    }
  );
}
